import { t } from "@lingui/macro";
import React from "react";
import { Path, Defs, Stop, LinearGradient } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DiscoverIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 12 12"
      width={24}
      height={24}
      title={t`Discover`}
      {...props}
    >
      <Path
        d="M12 6.0038C12 9.31899 9.31519 12.0038 6 12.0038C2.68481 12.0038 0 9.31519 0 6.0038C0 2.6924 2.68481 0 6 0C9.31519 0 12 2.68861 12 6V6.0038Z"
        fill="url(#paint0_linear_7927_2393)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_7927_2393"
          x1="9.07215"
          y1="10.8114"
          x2="4.91772"
          y2="4.30633"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F9A020" />
          <Stop offset="0.25" stopColor="#F89B20" />
          <Stop offset="0.53" stopColor="#F68D20" />
          <Stop offset="0.62" stopColor="#F68820" />
          <Stop offset="0.73" stopColor="#F58120" />
          <Stop offset="1" stopColor="#F47521" />
        </LinearGradient>
      </Defs>
    </Icon>
  );
};
